import { makeVar } from '@apollo/client'

export const CurrentResourcePageNumber = makeVar<number>(0)
export const CurrentRouterPath = makeVar<string | null>(null)
export const CurrentRouterUrl = makeVar<string | null>(null)
